export default [{
      path: '/cluster-groups',
      component: () => import('../pages/clusters/Index.vue'),
      children: [
          {
            path: '',
            name: 'cluster-groups/list',
            meta: {
                parentPath: '/clusters',
                layout: 'default',
                breadcrumb: [{ label: 'Clusters' }],
            },
            component: () => import('../pages/cluster-groups/ClusterGroups.vue'),
          },
          {
            path: 'cluster-groups/add',
            name: 'cluster-groups/add',
            meta: {
                parentPath: '/clusters',
                layout: 'default',
                breadcrumb: [{ label: 'Clusters' }],
            },
            component: () => import('../pages/cluster-groups/AddEditClusterGroup.vue'),
          },
          {
            path: ':id/edit',
            name: 'cluster-groups/edit',
            meta: {
                parentPath: '/deployments',
                layout: 'default',
                breadcrumb: [{ label: 'Cluster Groups', to: { name: 'cluster-groups/list' } }, { label: 'Edit Cluster Group' }],
            },
            component: () => import('../pages/cluster-groups/AddEditClusterGroup.vue'),
          },
          {
            path: ':id',
            name: 'cluster-groups/detail',
            meta: {
                parentPath: '/clusters',
                layout: 'default',
                breadcrumb: [{ label: 'Clusters' }],
            },
            component: () => import('../pages/cluster-groups/ClusterGroupDetail.vue'),
          }
      ]
  }]